import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;


export const validationSchema = Yup.object({
    nameLat: Yup.string()
        .required("Le nom est obligatoire")
        .max(150, "150 caractères max"),

    familyId: Yup.number()
        .required("La famille est obligatoire")
        .moreThan(0, "Veuillez sélectionner une famille"),
});


const SubFamilies = () => {
    const [families, setFamilies] = useState([]);
    const [subFamilies, setSubFamilies] = useState([]);

    const [selectedSubFamily, setSelectedSubFamily] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchFamilies();
        fetchSubFamilies();
    }, []);

    const fetchFamilies = () => {
        axiosInstance.get(`${baseUrl}/api/Families`)
            .then(res => setFamilies(res.data))
            .catch(() => console.log("Impossible de charger les familles"))
            .finally(() => setLoading(false));
    };

    const fetchSubFamilies = () => {
        axiosInstance.get(`${baseUrl}/api/SubFamilies`)
            .then(res => setSubFamilies(res.data))
            .catch(() => console.log("Impossible de charger les familles"))
            .finally(() => setLoading(false));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            nameAr: "",
            nameLat: "",
            descriptionAr: "",
            descriptionLat: "",
            familyId: 0,
            familyName: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {
            const url = values.id
                ? `${baseUrl}/api/SubFamilies/UpdateSubFamily`
                : `${baseUrl}/api/SubFamilies/CreateSubFamily`;

            const payload = {
                ...values,
                id: parseInt(values.id, 10),
                familyId: parseInt(values.familyId, 10),
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchSubFamilies();
                resetForm();
                setSelectedSubFamily(null);

            } catch (error) {
                // 🔴 erreurs serveur (ModelState / ServiceResponse)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });
    const resetForm = () => {
        formik.resetForm();
        setSelectedSubFamily(null);
    };
    const handleEdit = (subFamily) => {
        setSelectedSubFamily(subFamily);
        formik.setValues(subFamily);
        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/SubFamilies/DeleteSubFamily`,
                    { 'id': id, 'idString': '' })
                    .then(() => fetchSubFamilies());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Sous Familles</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm"><i className="fas fa-plus"></i>Ajouter</button>

            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title="Liste des sous familles"
                    columns={["nameLat", "descriptionLat", "familyName"]}
                    columnsMapping={{
                        nameLat: "Nom",
                        descriptionLat: "Description",
                        familyName: "Famille"
                    }}
                    keyField="id"
                    data={subFamilies}
                    handleEdit={handleEdit}
                    handleDelete={(id) => handleDelete(id)}
                />
            )}

            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedSubFamily ? "Modifier" : "Ajouter"} une famille</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={resetForm}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label></div>
                            <input
                                type="text"
                                name="nameLat"
                                className={`form-control ${formik.touched.nameLat && formik.errors.nameLat ? "is-invalid" : ""
                                    }`}
                                value={formik.values.nameLat}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.nameLat && formik.errors.nameLat && (
                                <div className="invalid-feedback">
                                    {formik.errors.nameLat}
                                </div>
                            )}                            <div className="form-group">
                                <label>Description</label>
                                <input
                                    type="text"
                                    name="descriptionLat"
                                    className={`form-control ${formik.touched.descriptionLat && formik.errors.descriptionLat ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.descriptionLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.descriptionLat && formik.errors.descriptionLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.descriptionLat}
                                    </div>
                                )}                            </div>
                            <div className="form-group">
                                <label>Famille</label>
                                <select
                                    name="familyId"
                                    className={`form-control ${formik.touched.familyId && formik.errors.familyId ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.familyId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">-- Sélectionnez --</option>
                                    {families.map(f => (
                                        <option key={f.id} value={f.id}>
                                            {f.nameLat}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.familyId && formik.errors.familyId && (
                                    <div className="invalid-feedback">
                                        {formik.errors.familyId}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-enregistrer" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubFamilies;
